import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import NewEmployers from "@/components/NewEmployers";
import NewSubBanner from "@/components/NewSubBanner";
import NewColumnTextWithForm from "@/components/NewColumnTextWithForm";
import { Container } from "reactstrap";

export default function TrainingApprenticeshipsPage({
  global,
  all_featured_employers,
}) {
  return (
    <>
      <SeoHead
        page_name={`Training and Apprenticeships | Project engineering and technical recruitment specialists | Carbon60`}
        canonical_link={`job-seekers/training-and-apprenticeships`}
      />
      <NewSubBanner
        global={global}
        pathPrefix={`training_apprenticeships.new_sub_banner`}
        customClass={``}
        content={
          <>
            <h1>Training and Apprenticeships</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/banner.webp`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={true}
        breadcrumb_title="Training & Apprenticeships"
        secondary_breadcrumb_url={"/job-seekers"}
        secondary_breadcrumb_title={"Job Seekers"}
      />
      <NewEmployers
        global={global}
        pathPrefix={`training_apprenticeships.featured_employers_page.new_employers`}
        buttonTitle={`Load More Employers`}
        post={all_featured_employers}
        customClass={`py-5`}
        pathURL={`training-and-apprenticeships/`}
      />
      <Container>
        <hr></hr>
      </Container>
      <NewColumnTextWithForm
        global={global}
        pathPrefix={`training_apprenticeships.featured_employers_page.new_column_text_with_form`}
        content={
          <>
            <h2>Drive better workforce performance</h2>
            <p>
              Book a call with us and find out how we can help you and your team
              achieve greater heights.
            </p>
          </>
        }
        formId={`607647da-41ad-4021-ac38-47d3d183200a`}
        customClass="py-5"
        locale=""
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const featured_employers = await Collection("training_and_apprenticeships");

  const all_featured_employers = featured_employers
    .orderBy("_order")
    .getItems();

  return {
    props: {
      global,
      all_featured_employers,
    },
  };
}
